var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentListCreateIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5875 1.87891H8.05813C7.5589 1.87891 7.08012 2.07722 6.72711 2.43023C6.3741 2.78324 6.17578 3.26203 6.17578 3.76126V18.8201C6.17578 19.3193 6.3741 19.7981 6.72711 20.1511C7.08012 20.5041 7.5589 20.7024 8.05813 20.7024H19.3523C19.8515 20.7024 20.3303 20.5041 20.6833 20.1511C21.0363 19.7981 21.2346 19.3193 21.2346 18.8201V7.52597M15.5875 1.87891L21.2346 7.52597M15.5875 1.87891V7.52597H21.2346M17.4699 12.2318H9.94049M17.4699 15.9966H9.94049M11.8228 8.46714H9.94049",
    stroke: "#150823",
    strokeWidth: 1.41176,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.82353 21.176H6.64706M5.23529 14.3733C5.3601 14.2093 5.52938 14.1172 5.70588 14.1172C5.79328 14.1172 5.87982 14.1398 5.96056 14.1838C6.04131 14.2277 6.11467 14.2921 6.17647 14.3733C6.23827 14.4546 6.28729 14.551 6.32074 14.6571C6.35418 14.7632 6.37139 14.8769 6.37139 14.9918C6.37139 15.1066 6.35418 15.2204 6.32074 15.3265C6.28729 15.4326 6.23827 15.529 6.17647 15.6102L2.2549 20.7637L1 21.176L1.31373 19.5269L5.23529 14.3733Z",
    stroke: "#150823",
    strokeWidth: 1.12941,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentListCreateIcon);
export default __webpack_public_path__ + "static/media/document-list-create-icon.b08ab1d69c51e2e2377f62a8af6feb23.svg";
export { ForwardRef as ReactComponent };